import { TrashIcon, ForwardIcon } from '@quickmd-llc/design-system'
import { DELETE_TEXT, PENDING_INVITATION_TEXT, PERSON_NOT_ACTIVATED_TEXT, RESEND_TEXT } from '../../../utils/constants'

type Props = {
  onDelete: () => void
  onResend: () => void
}

/**
 * Pending-invitation banner shown for unverified providers. Carved verbatim from the legacy
 * `member.jsx` render (the Delete / Resend invite actions for a not-yet-activated provider).
 */
export function PendingInvitationBanner({ onDelete, onResend }: Props) {
  return (
    <div className='flex items-center gap-sp-0.5 rounded-lg border border-shade-10 bg-white p-sp-3'>
      <div className='flex flex-1 flex-col gap-[4px]'>
        <span className='text-base font-semibold tracking-[0.12px] text-text-dark'>{PENDING_INVITATION_TEXT}</span>
        <span className='text-sm tracking-[0.12px] text-text-medium'>{PERSON_NOT_ACTIVATED_TEXT}</span>
      </div>
      <div className='flex items-center gap-sp-1'>
        <button
          type='button'
          className='flex items-center gap-sp-1 rounded-full border border-shade-10 bg-surface-error px-sp-2 py-[6px] text-sm font-semibold tracking-[0.12px] text-text-error'
          onClick={onDelete}>
          <TrashIcon iconSize='s' />
          {DELETE_TEXT}
        </button>
        <button
          type='button'
          className='flex items-center gap-sp-1 rounded-full border border-shade-10 bg-surface-active px-sp-2 py-[6px] text-sm font-semibold tracking-[0.12px] text-text-highlight'
          onClick={onResend}>
          <ForwardIcon iconSize='s' />
          {RESEND_TEXT}
        </button>
      </div>
    </div>
  )
}
